export default "__VITE_ASSET__ChgUZNpI__"